export class OSServicos {
    Id: string;
    // IdOrdemServico: number; /* para mockup armazenar os dados de OSServicos dentro do OrdemServico */
    IdServicoSolicitacao: number;
    IdServicoExecucao: number;
    IdPessoa: number; // Técnico
    TempoExecucao: number;
    SolucionavelAtendimento: string;
    OSPontos: OSPontos[] = [];
    OSItens: OSItens[] = [];
}

class OSPontos {
    // IdOSServico: number; /* para mockup armazenar os dados de OSPontos dentro do OSServicos */
    IdProdutoPacote: number;
    IdItemSerie: number;
    IdPontoTipo: number;
    IdMotivoCancelamento: number;
    DescricaoLocalizacao: string;
    EquipamentoRecolhido: string;
}

class OSItens {
    // IdOSServico: number; /* para mockup armazenar os dados de OSPontos dentro do OSServicos */
    IdItem: number;
    Quantidade: number;
}

export class OSEstados {
    // IdOrdemServico: number; /* para mockup armazenar os dados de OSServicos dentro do OrdemServico */
    IdEstadosAndamento: number;
    DtHrOSEstado: Date;
}

export class OrdemServico {
    Id: number;
    OrdemServicoTipo: string;
    DtHrCadastro: Date;
    DescricaoSolicitacao: string;
    VisitaImprodutiva: string;
    Observacao: string;
    OSServicos: OSServicos[] = [];
    OSEstados: OSEstados[] = [];
    IdEquipe: number;
    IdProtocolo: number;
}

/*
// Consta no modelo, porém para mockup vamos utilizar OrdemServico direto, pois não tem nenhum atributo específico para OSAvulsa
export class OSAvulsa extends OrdemServico {

}
*/

export class OSAtendimento extends OrdemServico {
    IdProcoloServico: number;
    IdServico: number;
}

export class OSTecnicoDeslocamento {
    Id: number;
    IdOrdemServico: number;
    IdPessoa: number;
    DtHrInicioDeslocamento: Date;
    LatLngInicioDeslocamento: string;
    DtHrFimDeslocamento: Date;
    LatLngFimDeslocamento: string;
    DtHrInicioAtendimento: Date;
    LatLngInicioAtendimento: string;
    DtHrFimAtendimento: Date;
    LatLngFimAtendimento: string;
    Observacao: string;
}



// WEBPACK FOOTER //
// ./src/app/ordem-servico/ordem-servico.model.ts